
import { actions, types } from './requests'
export const GETARTICLEVARIANTIMAGELIST_TYPES = {
    ...types('GETARTICLEVARIANTIMAGELIST'),
}
export const GETARTICLEVARIANTIMAGELIST_ACTIONS = {
    ...actions('GETARTICLEVARIANTIMAGELIST'),
}